import { render, staticRenderFns } from "./weixinPcLogin.vue?vue&type=template&id=5bdcf50a&scoped=true&"
import script from "./weixinPcLogin.vue?vue&type=script&lang=js&"
export * from "./weixinPcLogin.vue?vue&type=script&lang=js&"
import style0 from "./weixinPcLogin.vue?vue&type=style&index=0&id=5bdcf50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdcf50a",
  null
  
)

export default component.exports